import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const useProfileImage = (user) => {
  const [profileImageUrl, setProfileImageUrl] = useState(null);

  useEffect(() => {
    const fileId = user ? user.profile_image_file_id : null;
    if (fileId) {
      axios.get(`${API_URL}/api/files/download/${fileId}`, {
        responseType: 'blob'
      }).then(res => {
        setProfileImageUrl(prev => {
          if (prev) URL.revokeObjectURL(prev);
          return URL.createObjectURL(res.data);
        });
      }).catch(() => {});
    }
    return () => {
      if (profileImageUrl) URL.revokeObjectURL(profileImageUrl);
    };
  }, [user?.profile_image_file_id]);

  return profileImageUrl;
};

export default useProfileImage;
